import React from 'react';
import {
  DEFAULT_GUIDANCE,
  DEEP_PROMPT_GUIDANCE,
  isDeepPrompt,
} from '../../utils/storybookGuidance';

export function StorybookAnswerGuidance({ promptText }) {
  const deep = isDeepPrompt(promptText);

  return (
    <aside
      className="rounded-xl border border-[hsl(38_14%_88%)]/50 bg-muted/15 px-4 py-3 text-[11px] leading-relaxed text-muted-foreground"
      data-testid="storybook-answer-guidance"
    >
      <p className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground/60">
        Gentle guidance
      </p>
      <ul className="space-y-1.5">
        <li>Suggested length: {DEFAULT_GUIDANCE.suggestedWords}</li>
        <li>Suggested time: {DEFAULT_GUIDANCE.suggestedTime}</li>
        <li>Voice answer: {DEFAULT_GUIDANCE.voiceGuide}</li>
      </ul>
      <p className="mt-3 italic text-muted-foreground/80">{DEFAULT_GUIDANCE.tip}</p>
      {deep ? (
        <div className="mt-3 space-y-1 border-t border-border/30 pt-3">
          <p className="font-medium text-foreground/70">This prompt can go deeper:</p>
          <p>{DEEP_PROMPT_GUIDANCE.short}</p>
          <p>{DEEP_PROMPT_GUIDANCE.full}</p>
          <p>{DEEP_PROMPT_GUIDANCE.chapter}</p>
        </div>
      ) : null}
    </aside>
  );
}

export default StorybookAnswerGuidance;
